module.exports = __webpack_public_path__ + "assets/img/2-1.f7897b68.jpg";